export enum NFT_RENDERER_SIZES {
  S = 'S',
  L = 'L',
}
